// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1661708671279
      var cssReload = require("C:/Users/Слава/Desktop/Работа Минск/сайт макета/work-post - пост отдельной работы/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"reloadAll":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  